// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"f0f426c7052746c20feb","263":"e92d284d31c1c4c17b55","791":"42de8efd46a5a027cc9d"}[chunkId] + ".js";
};